(function(jQuery) {


}(eventgallery.jQuery));
